import React, { useState, useEffect } from "react";
import "./Services.css";

const Services = () => {
  const [sliderImages, setSliderImages] = useState([]);
  const [services, setServices] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    service: "",
    destination: "",
    startDate: "",
    endDate: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const SHEET_URL = "https://script.google.com/macros/s/AKfycbzw5l4UzY-RYk2mLu4GJGcrrGXAj18i6lyKEfZ3Dlt1wH2iQWhqCuZbeQMoGfV-XlpxjQ/exec";

  useEffect(() => {
    fetch(`${SHEET_URL}?sheet=HolidaySlider`)
      .then((res) => res.json())
      .then(setSliderImages);

    fetch(`${SHEET_URL}?sheet=OtherServices`)
      .then((res) => res.json())
      .then(setServices);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const SHEETDB_POST_URL = "https://sheetdb.io/api/v1/ae9gsiyuffbwu";
  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await fetch(SHEETDB_POST_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: formData }),
    });

    const result = await response.json();
    if (result.created === 1) {
      setSubmitted(true);
      setFormData({
        name: "",
        contact: "",
        email: "",
        service: "",
        destination: "",
        startDate: "",
        endDate: "",
      });
      setTimeout(() => {
        setSubmitted(false);
        setFormVisible(false);
      }, 3000);
    }
  } catch (error) {
    console.error("Submission Error", error);
  }
};

  return (
    <div className="services-page">
      <div className="services-banner">
        <h1>Single Tap Services</h1>
      </div>

      <section className="holiday-section">
        <h2>Single Tap Holiday Packages</h2>
        <div className="slider">
          {sliderImages.map((item, idx) => (
            <a key={idx} href="/holiday-packages" target="_blank" rel="noreferrer">
              <img src={item.ImageURL} alt={`Slide ${idx}`} className="slider-img" />
            </a>
          ))}
        </div>
        <p className="service-para">
          Welcome to Single Tap Holiday Packages. We bring you curated travel plans crafted to suit your needs. From adventure getaways to peaceful retreats, our packages are tailored for every traveler.<br /><br />
          Discover new cultures, foods, and landscapes, all handpicked by our expert team. We're here to make your travel as seamless and joyful as possible.
        </p>
        <a href="/holiday-packages" target="_blank" rel="noreferrer" className="know-more-btn">Know More</a>
      </section>

      <section className="other-services">
        <h2>Other Services on Single Tap</h2>
        <div className="services-grid">
          {services.map((service, idx) => (
            <div className="service-card" key={idx}>
              <img src={service.ImageURL} alt={service.Title} />
              <h3>{service.Title}</h3>
              <p>{service.Description}</p>
              <button onClick={() => setFormVisible(true)}>Book Now</button>
            </div>
          ))}
        </div>
      </section>

      {formVisible && (
        <div className="popup-overlay">
          <div className="popup-form">
            <button className="popup-close" onClick={() => setFormVisible(false)}>×</button>
            <h3>Book Your Service</h3>
            <form onSubmit={handleSubmit}>
              <input name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
              <input name="contact" placeholder="Contact Number" value={formData.contact} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
              <select name="service" value={formData.service} onChange={handleChange} required>
                <option value="">Select Service</option>
                <option value="Accommodation">Accommodation</option>
                <option value="Transportation">Transportation</option>
                <option value="Other Activities">Other Activities</option>
              </select>
              <input name="destination" placeholder="Destination" value={formData.destination} onChange={handleChange} required />
              <input type="date" name="startDate" value={formData.startDate} onChange={handleChange} required />
              <input type="date" name="endDate" value={formData.endDate} onChange={handleChange} required />
              <button type="submit">Get Now</button>
            </form>
            {submitted && <p className="success-msg">Thank you! We'll connect with you shortly.</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
